import { Input } from "antd";
import React from "react";

const ALLOWED_KEYS = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"];

const WeightageInput = ({ value, onChange, ...rest }) => {
  const onKeyDown = (e) => {
    if (ALLOWED_KEYS.includes(e.key) || e.ctrlKey || e.metaKey) return;
    if (!/^[0-9]$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "");
    if (digits === "") {
      onChange(undefined);
      return;
    }
    onChange(Math.min(100, Number(digits)));
  };

  return (
    <Input value={value ?? ""} onKeyDown={onKeyDown} onChange={handleChange} maxLength={3} {...rest} />
  );
};

export default WeightageInput;
